export default __webpack_public_path__ + "static/media/AboutMe.590f1f8e.png";